var _path, _path2, _path3, _path4, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgReports(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 23,
    viewBox: "0 0 21 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.5137 17.0051H6.53577C6.07831 17.0051 5.70703 16.6339 5.70703 16.1764C5.70703 15.7189 6.07831 15.3477 6.53577 15.3477H14.5137C14.9712 15.3477 15.3425 15.7189 15.3425 16.1764C15.3425 16.6339 14.9712 17.0051 14.5137 17.0051Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.5137 12.3811H6.53577C6.07831 12.3811 5.70703 12.0098 5.70703 11.5524C5.70703 11.0949 6.07831 10.7236 6.53577 10.7236H14.5137C14.9712 10.7236 15.3425 11.0949 15.3425 11.5524C15.3425 12.0098 14.9712 12.3811 14.5137 12.3811Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.58 7.7649H6.53577C6.07831 7.7649 5.70703 7.39362 5.70703 6.93616C5.70703 6.4787 6.07831 6.10742 6.53577 6.10742H9.58C10.0375 6.10742 10.4087 6.4787 10.4087 6.93616C10.4087 7.39362 10.0375 7.7649 9.58 7.7649Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_18428_7642",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 21,
    height: 23
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.463867 0.459961H20.5356V22.46H0.463867V0.459961Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_18428_7642)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.7265 2.11733L6.23026 2.12175C3.65786 2.13722 2.11972 3.72839 2.11972 6.37925V16.5407C2.11972 19.2092 3.67222 20.8026 6.27004 20.8026L14.7663 20.7993C17.3387 20.7838 18.8768 19.1904 18.8768 16.5407V6.37925C18.8768 3.71071 17.3254 2.11733 14.7265 2.11733ZM6.27179 22.4602C2.79772 22.4602 0.462891 20.0812 0.462891 16.5408V6.37936C0.462891 2.80695 2.72479 0.485376 6.22538 0.464381L14.726 0.459961H14.7271C18.2012 0.459961 20.5349 2.83899 20.5349 6.37936V16.5408C20.5349 20.1121 18.273 22.4348 14.7724 22.4569L6.27179 22.4602Z",
    fill: "black"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReports);
export default __webpack_public_path__ + "static/media/Reports.26c36db9b128ec47193666b0ff349aef.svg";
export { ForwardRef as ReactComponent };